import { AppBar, Avatar, Box, IconButton, Toolbar, Typography } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useAuth } from '../../contexts/AuthContext';

import './TopMenu.scss';

export function TopMenu() {
  const { isAuthenticated } = useAuth();

  return (
    <AppBar
      position="static"
      component="nav"
      elevation={0}
      sx={{
        backgroundColor: '#fff',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15) !important',
        zIndex: 1000
      }}
    >
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {
            isAuthenticated ?
              <Avatar src="/logo.svg" alt="Logo" sx={{ width: 32, height: 32 }} />
              :
              <Avatar src="/logo-field-eng.svg" alt="Logo" sx={{ width: 29, height: 24 }} />
          }
          <Typography className='title'>
            First<span>Freight</span>
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <IconButton>
            <NotificationsIcon />
          </IconButton>
          <Avatar sx={{ bgcolor: '#007bff', color: '#fff' }}>OP</Avatar>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
